<template>
  <ucar-mask>
    <div class="vehicle-tips">
      <div class="vehicle-tips-header">
        车辆要求
      </div>
      <ul>
        <li v-for="item in list" :key="item">{{item}}</li>
      </ul>
      <div>
        <ucar-button size="full" @click.native="hide">我知道了</ucar-button>
      </div>
    </div>
  </ucar-mask>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    hide () {
      this.$emit('hide')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.vehicle-tips {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 60px 30px 30px 30px;
  margin: 0 45px;
  background-color: #fff;

  .vehicle-tips-header {
    text-align: center;
    height: 34px;
    line-height: 34px;
    font-size: $ucar_font_h4;
    margin-bottom: 30px;
    color: $ucar_font_color;
  }

  ul {
    margin-bottom: 30px;
    padding-left: 1.2em;

    li {
      list-style: disc outside;
      font-size: 28px;
      line-height: 1.8;
      color: $ucar_font_color;
    }
  }
}
</style>